module.exports = __webpack_public_path__ + "img/logo-notr-web.bf79634f.svg";